import { Component, ViewChild } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { LoginRequired } from "../../decorators/login.required";
import { NavController, NavParams } from "ionic-angular";
import { ApiService } from "../../services/api.service";
import { PageTitleService } from "../../services/page-title.service";
import { User, ViewDidEnter } from "../../app/app.interfaces";
import { EventService } from "../../services/event.service";
import { IonicHelper } from "../../helpers/ionic.helper";
import { PostListContainer } from "../../partials/post/post-list-container/post-list-container";


@Component({
	selector: 'profile',
	templateUrl: 'profile.html'
})

@LoginRequired()

export class Profile implements ViewDidEnter {

	user: User;
	ownProfile: boolean = false;
	postListContainer: any = PostListContainer;
	
	mobileTitle = 'profile';
	hideSpinner: boolean = false;

	@ViewChild('postListNav') postListNav: NavController;

	constructor(public authService: AuthService,
							private nav: NavController,
							private navParams: NavParams,
							private apiService: ApiService,
							private pageTitleService: PageTitleService,
              private ionic: IonicHelper,
							private eventService: EventService) {
	}

	ionViewDidEnter(): void {
		
		this.getUserForProfile();



	}

	getUserForProfile(): void{
		let userId = this.navParams.get('userId');
		if(userId===undefined || parseInt(userId)===this.authService.user.id) {
			this.pageTitleService.setPageTitle('my-profile');
			this.mobileTitle = 'my-profile';
			this.ownProfile = true;
			this.user = this.authService.user;
		}
		else {
			this.ownProfile = false;

			this.apiService.getResourceById('users', userId).then((user: User) => {
				this.pageTitleService.setPageTitle('profile', user);
				this.mobileTitle = 'profile';
				this.ownProfile = false;
				this.user = user;

			}, (err: any) => {
        this.hideSpinner = true;
        this.ionic.uncoverableErrorAlert('PROFILE_NOT_FOUND');
			});

		}
	}
	
	setUserEnabled(enabled: boolean) {
	  
    if(!this.authService.user.admin) {
      throw new Error('User must be admin for this');
    }	  
	  
    this.apiService.updateResource(this.user, { enabled: enabled }).then((user: User) => {      
      this.user.enabled = enabled;      
      this.ionic.toast( enabled ? 'ADMIN.USER_UNBLOCKED_TOAST' : 'ADMIN.USER_BLOCKED_TOAST');      
    }).catch((err) => {
    	console.error(err);    	
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
		});
	
  }

}



// WEBPACK FOOTER //
// ./src/components/profile/profile.ts